import * as api from 'api/users';

export const UPDATE_USER = 'UPDATE_USER'
export const VERIFY_USER_EMAIL = 'VERIFY_USER_EMAIL'
export const REFRESH_USER_DATA = 'REFRESH_USER_DATA'

export const updateUser = (id, data) => ({
  type: UPDATE_USER,
  payload: api.updateUser(id, data),
});

export const verifyUserEmail = (id, code) => ({
  type: VERIFY_USER_EMAIL,
  payload: api.verifyUserEmail(id, code),
});

export const refreshUserData = (id) => ({
  type: REFRESH_USER_DATA,
  payload: api.showUser(id),
});
